import { styled } from "@vitality-ds/system";
import BaseDialogActionsStyles from "./styles/BaseDialogActions.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseDialogActions = styled("div", BaseDialogActionsStyles);